import React, { forwardRef } from "react";
import { isInternalDomain } from "@stadium/helpers/routes";

export const ExtLink = forwardRef(
  ({ target = "_blank", className = " ", children, ...restProps }, ref) => {
    const rel = isInternalDomain({ url: restProps.href }) ? "noopener" : "noopener noreferrer";
    return (
      <a target={target} className={className} rel={rel} ref={ref} {...restProps}>
        {children}
      </a>
    );
  },
);
